"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BUSINESS_METADATA_DISABLED_BY_ADMIN = exports.BUSINESS_METADATA_GCA_SWIFT_PAYMENTS_ENABLED = void 0;
exports.isGcaSwiftPaymentsEnabledForBusiness = isGcaSwiftPaymentsEnabledForBusiness;
exports.isBusinessDisabledByAdmin = isBusinessDisabledByAdmin;
exports.isAcceptedSwiftOnProject = isAcceptedSwiftOnProject;
exports.resolveProjectSourceApp = resolveProjectSourceApp;
/** Top-level `business.metadata` key — ops enables GCA SWIFT per merchant. */
exports.BUSINESS_METADATA_GCA_SWIFT_PAYMENTS_ENABLED = "gcaSwiftPaymentsEnabled";
function isGcaSwiftPaymentsEnabledForBusiness(metadata) {
    return metadata?.[exports.BUSINESS_METADATA_GCA_SWIFT_PAYMENTS_ENABLED] === true;
}
/** Top-level `business.metadata` key — internal dashboard ops disables a business without a full KYC status change. */
exports.BUSINESS_METADATA_DISABLED_BY_ADMIN = "disabledByAdmin";
function isBusinessDisabledByAdmin(metadata) {
    return metadata?.[exports.BUSINESS_METADATA_DISABLED_BY_ADMIN] === true;
}
function isAcceptedSwiftOnProject(projectMetadata) {
    const raw = projectMetadata?.["acceptedPaymentMethods"];
    if (raw == null || typeof raw !== "object") {
        return false;
    }
    return raw["swift"] === true;
}
function resolveProjectSourceApp(sourceApp) {
    const normalized = String(sourceApp ?? "")
        .trim()
        .toLowerCase();
    return normalized === "nucleus" ? "nucleus" : "handshake";
}
